<template>
  <div class="moderator-candidate-resumes-actions">
    <button @click.prevent="$vModal.open('am-candidates-resumes-page-actions-filter')"
            class="moderator-candidate-resumes-actions__filter-btn">
      <BaseSvg name="ico-filter"/>
      <span v-if="quantity">{{ quantity }}</span>
    </button>

    <div class="moderator-candidate-resumes-actions__middle">
      <AMCandidatesResumesPageActionsSearch :querySearchTypes="querySearchTypes"/>
      <AMCandidatesResumesPageActionsSort/>
    </div>

    <router-link-modified v-if="showClear"
                          :to="{query: {page: $route.query.page}}"
                          class="moderator-candidate-resumes-actions__clear">
      {{ $tModeratorCandidates('Clear') }}
    </router-link-modified>
    <div v-else
         style="opacity: 0.3;"
         class="moderator-candidate-resumes-actions__clear">
      {{ $tModeratorCandidates('Clear') }}
    </div>
  </div>
</template>

<script>
  import AMCandidatesResumesPageActionsSearch from './AMCandidatesResumesPageActionsSearch'
  import AMCandidatesResumesPageActionsSort from './AMCandidatesResumesPageActionsSort'

  export default {
    name: 'AMCandidatesResumesPageActions',
    components: {
      AMCandidatesResumesPageActionsSearch,
      AMCandidatesResumesPageActionsSort
    },
    props: {
      queryFilterKeys: Array,
      querySearchTypes: Array,
    },
    data() {
      return {}
    },
    computed: {
      quantity() {
        const query = this.$route.query

        return this.queryFilterKeys.reduce((sum, key) => {
          if (query[key]) {
            sum += 1
          }

          return sum
        }, 0)
      },
      showClear() {
        const query = this.$route.query

        for (const key in query) {
          if(key === 'page') {
            continue
          }

          if(query[key]) {
            return true
          }
        }

        return false
      }
    }
  }
</script>

<style lang="less">

</style>
